import urljoin from 'url-join';
import { portalApi } from './index.api';
import { useIsAuthenticated } from '@/hooks/useIsAuthenticated';

export const currentUserApi = portalApi.injectEndpoints({
	endpoints: (builder) => ({
		currentUser: builder.query({
			query: () => ({
				// baseQueryWithAuth handles authorization header automatically
				url: urljoin('users', 'current'),
				method: 'GET',
			}),
			providesTags: (result, err, arg) => [{ type: 'user', id: arg?.email }],
		}),
		emailContains: builder.query({
			query: (text) => ({
				// baseQueryWithAuth handles authorization header automatically
				url: urljoin('users', 'email', 'contains', text),
				method: 'GET',
			}),
		}),
		detailsContains: builder.query({
			query: (text) => ({
				// baseQueryWithAuth handles authorization header automatically
				url: urljoin('users', 'details', 'contains', text),
				method: 'GET',
			}),
		}),
		acceptEula: builder.mutation({
			query: () => ({
				// baseQueryWithAuth handles authorization header automatically
				url: urljoin('users', 'current', 'eula-acceptance'),
				method: 'POST',
			}),
			invalidatesTags: (result, err, arg) => [{ type: 'user' }],
		}),
		learningCenterLinks: builder.query({
			query: () => ({
				url: urljoin('users', 'current', 'learning-center-links'),
				method: 'GET',
			}),
			providesTags: [{ type: 'user', id: 'learning-center-links' }],
		}),
	})
});

export const {
	useCurrentUserQuery,
	useEmailContainsQuery,
	useDetailsContainsQuery,
	useAcceptEulaMutation,
	useLearningCenterLinksQuery,
} = currentUserApi;

export const useCurrentUser = () => {
	const isAuthenticated = useIsAuthenticated();
	return useCurrentUserQuery('', { skip: !isAuthenticated });
};
//TODO user login auth
//security redirect
//user selector
//managed projects
//publishing center

/* 
√ GET /api/v1/users/current
√ GET /api/v1/users/email/contains/{text}
√ GET /api/v1/users/details/contains/{text}
*/